import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeInquirySource} from "../../../application/tracking/amplitude/get_amplitude_inquiry_source";
import {ApplicationSource} from "../../../application/utils/form/application_form_source";
import {IRegionListRegion} from "../../../search/actions/fetch_search_regions_action";
import {IPreferencesDefaultValues} from "../../types/IPreferencesDefaultValues";

export const PREFERENCES_MODAL_LOCATION = "rp_preferences_modal";
const MULTILEAD_BUTTON_CATEGORY = "rp_multilead";

export interface IMultileadPreferencesAmplitudeContext {
    source: ApplicationSource;
    itemId: number;
    propertyId: number;
    transactionId: string;
}

interface IMultileadPreferencesEventParams {
    context: IMultileadPreferencesAmplitudeContext;
    values: IPreferencesDefaultValues;
    autoMatchEnabled: boolean;
    regionDetails?: IRegionListRegion[];
}

const parseRoomValue = (value: number | string | undefined): number | null => {
    if (value === undefined || value === "") {
        return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

const getPreferenceRooms = (values: IPreferencesDefaultValues): string[] => {
    const lower = parseRoomValue(values.rooms.lower);
    const upper = parseRoomValue(values.rooms.upper);

    if (lower !== null && upper !== null && upper >= lower) {
        return Array.from({length: upper - lower + 1}, (_, index) => String(lower + index));
    }

    return Array.from(new Set([lower, upper].filter((room): room is number => room !== null))).map(String);
};

const getPreferenceRegionNames = (values: IPreferencesDefaultValues, regionDetails?: IRegionListRegion[]): string[] => {
    const regions = values.regionSelector.length ? values.regionSelector : values.regions;
    // Region options built from bare preference IDs carry empty labels - resolve names from regionDetails
    // the same way the summary modal does (see getHomeMatchBasicRegionText)
    const regionNames = regionDetails?.length ? regionDetails.map((region) => region.short_name || region.name) : regions.map((region) => String(region.label));

    return regionNames.filter(Boolean);
};

export const serializeMultileadPreferences = (values: IPreferencesDefaultValues, regionDetails?: IRegionListRegion[]) => ({
    selected_regions: getPreferenceRegionNames(values, regionDetails).join("|"),
    rooms: getPreferenceRooms(values),
    budget: values.budget
});

export const serializeHomeMatchPreferences = (values: IPreferencesDefaultValues, regionDetails?: IRegionListRegion[]) => ({
    selected_locations: getPreferenceRegionNames(values, regionDetails),
    rooms: getPreferenceRooms(values),
    budget: values.budget
});

const getBaseEventProperties = ({context, values, autoMatchEnabled, regionDetails}: IMultileadPreferencesEventParams) => ({
    location: PREFERENCES_MODAL_LOCATION,
    inquiry_source: getAmplitudeInquirySource(context.source),
    lead_type: "multi_lead",
    form_location: "property_page",
    item_id: context.itemId,
    property_id: context.propertyId,
    transaction_id: context.transactionId,
    ...serializeMultileadPreferences(values, regionDetails),
    rp_auto_match_enabled: autoMatchEnabled
});

export const trackMultileadPreferencesView = (params: IMultileadPreferencesEventParams) => {
    trackAmplitudeEvent("view_preferences_modal", getBaseEventProperties(params));
};

export const trackMultileadPreferencesChange = (context: IMultileadPreferencesAmplitudeContext) => {
    trackAmplitudeEvent("button_click", {
        button_name: "rp_preferences_change",
        value: "ZMIEŃ",
        button_link: null,
        button_category: MULTILEAD_BUTTON_CATEGORY,
        item_id: context.itemId,
        property_id: context.propertyId
    });
};

export const trackMultileadPreferencesClose = (params: IMultileadPreferencesEventParams) => {
    const {context, values, autoMatchEnabled, regionDetails} = params;

    trackAmplitudeEvent("button_click", {
        button_name: "rp_preferences_modal_close",
        value: "close_without_save",
        button_link: null,
        button_category: MULTILEAD_BUTTON_CATEGORY,
        item_id: context.itemId,
        property_id: context.propertyId,
        rp_auto_match_enabled: autoMatchEnabled,
        ...serializeMultileadPreferences(values, regionDetails)
    });
};

export const trackMultileadPreferencesSaved = (params: IMultileadPreferencesEventParams) => {
    trackAmplitudeEvent("hm_preferences_saved", {
        ...getBaseEventProperties(params),
        button_category: MULTILEAD_BUTTON_CATEGORY
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeInquirySource} from "../../../application/tracking/amplitude/get_amplitude_inquiry_source";
import {ApplicationSource} from "../../../application/utils/form/application_form_source";
import {IRegionListRegion} from "../../../search/actions/fetch_search_regions_action";
import {IPreferencesDefaultValues} from "../../types/IPreferencesDefaultValues";

export const PREFERENCES_MODAL_LOCATION = "rp_preferences_modal";
const MULTILEAD_BUTTON_CATEGORY = "rp_multilead";

export interface IMultileadPreferencesAmplitudeContext {
    source: ApplicationSource;
    itemId: number;
    propertyId: number;
    transactionId: string;
}

interface IMultileadPreferencesEventParams {
    context: IMultileadPreferencesAmplitudeContext;
    values: IPreferencesDefaultValues;
    autoMatchEnabled: boolean;
    regionDetails?: IRegionListRegion[];
}

const parseRoomValue = (value: number | string | undefined): number | null => {
    if (value === undefined || value === "") {
        return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

const getPreferenceRooms = (values: IPreferencesDefaultValues): string[] => {
    const lower = parseRoomValue(values.rooms.lower);
    const upper = parseRoomValue(values.rooms.upper);

    if (lower !== null && upper !== null && upper >= lower) {
        return Array.from({length: upper - lower + 1}, (_, index) => String(lower + index));
    }

    return Array.from(new Set([lower, upper].filter((room): room is number => room !== null))).map(String);
};

const getPreferenceRegionNames = (values: IPreferencesDefaultValues, regionDetails?: IRegionListRegion[]): string[] => {
    const regions = values.regionSelector.length ? values.regionSelector : values.regions;
    // Region options built from bare preference IDs carry empty labels - resolve names from regionDetails
    // the same way the summary modal does (see getHomeMatchBasicRegionText)
    const regionNames = regionDetails?.length ? regionDetails.map((region) => region.short_name || region.name) : regions.map((region) => String(region.label));

    return regionNames.filter(Boolean);
};

export const serializeMultileadPreferences = (values: IPreferencesDefaultValues, regionDetails?: IRegionListRegion[]) => ({
    selected_regions: getPreferenceRegionNames(values, regionDetails).join("|"),
    rooms: getPreferenceRooms(values),
    budget: values.budget
});

export const serializeHomeMatchPreferences = (values: IPreferencesDefaultValues, regionDetails?: IRegionListRegion[]) => ({
    selected_locations: getPreferenceRegionNames(values, regionDetails),
    rooms: getPreferenceRooms(values),
    budget: values.budget
});

const getBaseEventProperties = ({context, values, autoMatchEnabled, regionDetails}: IMultileadPreferencesEventParams) => ({
    location: PREFERENCES_MODAL_LOCATION,
    inquiry_source: getAmplitudeInquirySource(context.source),
    lead_type: "multi_lead",
    form_location: "property_page",
    item_id: context.itemId,
    property_id: context.propertyId,
    transaction_id: context.transactionId,
    ...serializeMultileadPreferences(values, regionDetails),
    rp_auto_match_enabled: autoMatchEnabled
});

export const trackMultileadPreferencesView = (params: IMultileadPreferencesEventParams) => {
    trackAmplitudeEvent("view_preferences_modal", getBaseEventProperties(params));
};

export const trackMultileadPreferencesChange = (context: IMultileadPreferencesAmplitudeContext) => {
    trackAmplitudeEvent("button_click", {
        button_name: "rp_preferences_change",
        value: "ZMIEŃ",
        button_link: null,
        button_category: MULTILEAD_BUTTON_CATEGORY,
        item_id: context.itemId,
        property_id: context.propertyId
    });
};

export const trackMultileadPreferencesClose = (params: IMultileadPreferencesEventParams) => {
    const {context, values, autoMatchEnabled, regionDetails} = params;

    trackAmplitudeEvent("button_click", {
        button_name: "rp_preferences_modal_close",
        value: "close_without_save",
        button_link: null,
        button_category: MULTILEAD_BUTTON_CATEGORY,
        item_id: context.itemId,
        property_id: context.propertyId,
        rp_auto_match_enabled: autoMatchEnabled,
        ...serializeMultileadPreferences(values, regionDetails)
    });
};

export const trackMultileadPreferencesSaved = (params: IMultileadPreferencesEventParams) => {
    trackAmplitudeEvent("hm_preferences_saved", {
        ...getBaseEventProperties(params),
        button_category: MULTILEAD_BUTTON_CATEGORY
    });
};
